
export function isChromeExtPopup(): boolean {
  return window.location.protocol === 'chrome-extension:';
}

export function isValidTab(tab: chrome.tabs.Tab): boolean {
  return (
    !!tab &&
    tab.id !== undefined &&
    tab.id !== chrome.tabs.TAB_ID_NONE &&
    !!tab.url &&
    !tab.url.startsWith('chrome://')
  );
}

export async function getActiveTab(): Promise<chrome.tabs.Tab | null> {
  try {
    const tabs: chrome.tabs.Tab[] = await chrome.tabs.query({ active: true, currentWindow: true });
    if (!!tabs && tabs.length > 0) {
      return tabs[0];
    }
  } catch (ex: unknown) {
    console.error('Failed to get Chrome active tab:', ex);
  }
  return null
}

export async function getActiveValidTab(): Promise<chrome.tabs.Tab | null> {
  const activeTab: chrome.tabs.Tab | null = await getActiveTab();
  return !!activeTab && isValidTab(activeTab) ? activeTab : null;
}

export async function getActiveTabUrl(): Promise<string> {
  if (typeof chrome !== 'undefined' && chrome.tabs) {
    // Running in a Chrome extension
    const activeTab: chrome.tabs.Tab | null = await getActiveTab();
    return activeTab?.url || '';
  } else {
    // Running in a regular web context
    return window.location.href;
  }
}

export async function getActiveTabUrlOrLocationHref(): Promise<string> {
  if (isChromeExtPopup() && chrome.tabs) {
    const activeTab: chrome.tabs.Tab | null = await getActiveTab();
    return activeTab?.url || '';
  } else {
    // Use window.location.href when not in a popup
    return window.location.href;
  }
}
